import { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import api from "@/lib/api";
import { PublicPage, PageHero, Seo } from "@/components/public/PublicChrome";

export default function Testimonials() {
  const [data, setData] = useState({ testimonials: [], industries: [] });
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.get(`/testimonials${filter !== "all" ? `?industry=${filter}` : ""}`).then((r) => setData(r.data)).catch(() => {});
  }, [filter]);

  return (
    <PublicPage>
      <Seo title="Customer Stories" description="How businesses grow with Fairview Systems." path="/testimonials" />
      <PageHero eyebrow="Trust Center" title="Customer Stories" subtitle="Real results from businesses building on Fairview Systems." />
      <div className="max-w-5xl mx-auto px-6 pb-24">
        {data.industries.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-6">
            {["all", ...data.industries].map((ind) => (
              <button key={ind} onClick={() => setFilter(ind)}
                className={`text-xs px-3 py-1.5 rounded-full border capitalize ${filter === ind ? "fv-gold-gradient text-[#0A0A0B] font-semibold border-transparent" : "border-white/10 text-[#A1A1AA]"}`}>{ind}</button>
            ))}
          </div>
        )}
        {data.testimonials.length === 0 ? (
          <div className="text-center py-16 text-[#52525B]" data-testid="testimonials-empty">
            <Quote className="w-8 h-8 mx-auto mb-2" />Customer stories coming soon.
          </div>
        ) : (
          <div className="grid md:grid-cols-2 gap-4" data-testid="testimonials-grid">
            {data.testimonials.map((t) => (
              <div key={t.id} className="rounded-2xl border border-white/8 bg-[#121214] p-6">
                <div className="flex gap-0.5 mb-3">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <Star key={i} className={`w-4 h-4 ${i < t.rating ? "text-[#D4AF37] fill-[#D4AF37]" : "text-white/15"}`} />
                  ))}
                </div>
                <p className="text-[#D4D4D8] text-sm mb-4">"{t.quote}"</p>
                {t.metric && <div className="text-[#D4AF37] text-sm font-semibold mb-2">{t.metric}</div>}
                <div className="text-white text-sm font-medium">{t.name}</div>
                <div className="text-xs text-[#71717A]">{t.company} · {t.industry}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </PublicPage>
  );
}
